import React, { createContext, useContext } from 'react'

type ReportsRuntimeContextValue = {
  refreshKey: number
  setReportError: (error: string | null) => void
}

const ReportsRefreshContext = createContext<ReportsRuntimeContextValue>({
  refreshKey: 0,
  setReportError: () => undefined,
})

export function ReportsRefreshProvider({
  refreshKey,
  setReportError,
  children,
}: {
  refreshKey: number
  setReportError: (error: string | null) => void
  children: React.ReactNode
}): React.ReactElement {
  return (
    <ReportsRefreshContext.Provider value={{ refreshKey, setReportError }}>
      {children}
    </ReportsRefreshContext.Provider>
  )
}

export function useReportsRefreshKey(): number {
  return useContext(ReportsRefreshContext).refreshKey
}

export function useReportsErrorActions(): Pick<
  ReportsRuntimeContextValue,
  'setReportError'
> {
  const { setReportError } = useContext(ReportsRefreshContext)
  return { setReportError }
}
